module.exports = __webpack_public_path__ + "static/img/twjd-sdr2.6834826.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdr2.png
// module id = 867
// module chunks = 0